<template>
  <article class="section section--full-width" v-if="!loading">
    <financial-statement
      v-if="modalActive != null"
      :financial-categories.sync="financialCategories"
      :financial-statement.sync="statement"
      :active.sync="modalActive"
      @success="success()"
      @cancel="modalActive = null"
    />

    <header class="section__header">
      <h2 class="section__title">
        <router-link :to="`/${fn_GET_PARENT_ROUTE($route)}/finances/overview`">
          Extrato
        </router-link>
      </h2>
    </header>

    <section class="section__wrapper section__wrapper--no-border">
      <router-view
        :ref="'finances-router-view'"
        :financial-categories.sync="financialCategories"
      />
    </section>
  </article>
</template>

<script>
import financialStatement from '@/components/modals/financialStatement'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'DrFinances',

  components: {
    financialStatement
  },

  data () {
    return {
      statement: {},
      modalActive: null,
      doctorOffices: [],
      selectedOffice: 0, // *é o ÍNDICE relativo ao select, não id
      loading: false,
      financialCategories: []
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    })
  },

  created () {
    this.getCategories()

    EventBus.$on('new-financial-statement', (payload) => {
      this.statement = payload.statement
      this.modalActive = true
    })
  },

  methods: {
    getCategories () {
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(`/financial_category`, this.$store.getters.getAuthHeader)
        .then((res) => (this.financialCategories = res.data))
        .then(() => {
          const url = `/${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor_financial_category`
          this.$http
            .get(url, this.$store.getters.getAuthHeader)
            .then((res) => (this.financialCategories = this.financialCategories.concat(res.data.data)))
            .catch(err => console.log(err))
        })
        .catch(err => console.log(err))
        .finally(() => this.fn_HIDE_PROGRESS())
    },

    edit (index) {
      this.modalActive = index
    },

    success () {
      this.modalActive = null

      EventBus.$emit('reload-finance-current-balance')
      EventBus.$emit('reload-finance-last-transactions')
      EventBus.$emit('reload-finance-graph')
      EventBus.$emit('reload-finance-transactions-list')
    }
  }
}
</script>
